var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardBooks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 194,
    height: 152,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.557 116.004v23.878H73.745a3.423 3.423 0 01-3.411-3.411v-17.056a3.422 3.422 0 013.411-3.411h64.812zM162.435 85.304v6.822h-7.572l-1.57-6.208-.169-.614h9.311zM144.356 85.304l.682 2.696 1.024 4.126M150.36 109.182l.851 3.411h-2.42v3.411M140.263 116.004H102.74a15.355 15.355 0 01-10.854-4.496 15.34 15.34 0 01-4.496-10.854 15.351 15.351 0 0115.35-15.35h32.851",
    stroke: "#CCD3DA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M137.296 92.126H102.74a8.528 8.528 0 100 17.056h37.523M162.435 109.182v3.411h-2.423l-.852-3.411h3.275zM146.062 92.126h.033l.616 2.492 1.089 4.33 2.56 10.234",
    stroke: "#CCD3DA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M137.296 92.126H102.74a8.528 8.528 0 100 17.056h37.523M162.435 92.126v17.056h-3.275l-2.592-10.234-1.605-6.413-.101-.409h7.573zM138.966 98.948h-.409M162.435 98.948h-5.867M131.735 98.946h-6.822M153.294 85.918L145.039 88l-.683-2.696-.578-2.285a3.4 3.4 0 01.389-2.58 3.412 3.412 0 012.1-1.548l1.637-.41a3.378 3.378 0 014.129 2.456l1.092 4.367.169.614zM135.795 78.481H97.623a3.411 3.411 0 010-6.822h43.936",
    stroke: "#CCD3DA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M144.356 85.303l-.578-2.284a3.4 3.4 0 01.389-2.58 3.412 3.412 0 012.1-1.548l1.637-.41M135.591 85.304H97.623A10.22 10.22 0 0187.39 75.07a9.708 9.708 0 01.819-3.99 10.184 10.184 0 019.414-6.243h47.757a3.421 3.421 0 013.411 3.41v1.606",
    stroke: "#CCD3DA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M135.795 78.481H97.623a3.411 3.411 0 010-6.822h43.936M86.366 75.207l-22.071 51.031-5.013 11.565a3.367 3.367 0 01-4.467 1.773l-15.659-6.756a3.425 3.425 0 01-1.822-1.884 3.414 3.414 0 01.048-2.619l.887-2.082 26.198-60.514 21.9 9.486z",
    stroke: "#CCD3DA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M97.214 50.133l-5.425 12.553-5.423 12.52-21.9-9.482L65.9 62.38c.172-.26.299-.549.374-.852l3.616-8.323 5.425-12.553a3.446 3.446 0 014.503-1.774l15.623 6.787a3.39 3.39 0 011.774 4.467z",
    stroke: "#CCD3DA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M91.824 62.686l-3.616 8.392-1.806 4.126h-.036l-21.9-9.483 1.433-3.34c.172-.26.299-.549.374-.852l3.616-8.323 21.9 9.48h.035zM51.778 85.749L27.25 126.237l-7.264 12.008a3.47 3.47 0 01-4.708 1.16l-11.666-7.06a3.463 3.463 0 01-1.16-4.71l.852-1.4 30.94-51.097 17.534 10.61z",
    stroke: "#CCD3DA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M66.274 61.53a2.75 2.75 0 01-.374.85l-7.06 11.667-7.062 11.701-17.534-10.61 7.096-11.666 7.062-11.701a3.386 3.386 0 014.672-1.125l11.666 7.06a3.346 3.346 0 011.534 3.823z",
    stroke: "#CCD3DA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M58.84 74.047l-7.062 11.701-17.534-10.61 7.096-11.666 17.5 10.575zM159.024 112.593h17.056v37.522h-17.056v-37.522zM148.791 139.882v-23.878M140.263 139.882h-1.706v-23.878h1.706",
    stroke: "#CCD3DA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M159.024 112.593v37.522h-3.411a6.82 6.82 0 01-6.822-6.822v-30.7h10.233zM119.796 25.434c17.056-8.528 22.173 4.81 22.173 17.055 0 12.245-10.234 29.473-22.173 19.234-11.939 10.233-22.172-6.989-22.172-19.234 0-12.244 5.116-25.583 22.172-17.055zM131.729 2.159s3.163 4.366-1.809 11.298c-4.972 6.931-10.124 5.33-10.124 5.33s-3.163-4.367 1.809-11.296c4.972-6.929 10.124-5.332 10.124-5.332zM169.257 85.303v3.412h-6.822v-3.412a3.41 3.41 0 116.822 0zM162.435 95.537h6.822v17.056h-6.822V95.537zM162.435 88.715h6.822v6.822h-6.822v-6.822zM165.847 76.781v5.117M169.258 85.31h.851a4.259 4.259 0 013.941 2.63 4.27 4.27 0 01.325 1.632v4.265M160.012 112.593h-8.798l-3.411-13.645-1.091-4.33 8.252-2.083 1.604 6.413 2.593 10.234.851 3.411z",
    stroke: "#CCD3DA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M154.964 92.535l-8.253 2.082-.614-2.491h-.035L145.039 88l8.255-2.082 1.569 6.208.101.41zM191.056 92.194l-6.039 20.399h-12.452l7.063-23.775 11.428 3.376z",
    stroke: "#CCD3DA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M191.062 92.202l-11.445-3.397.971-3.27 4.252-2.297 4.89 1.454 2.301 4.241-.969 3.27zM186.313 112.593v30.7a6.818 6.818 0 01-6.822 6.822h-3.411v-37.522h10.233z",
    stroke: "#CCD3DA",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgDashboardBooks;